import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Firestore, collection, addDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-gift',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './gift.component.html',
  styleUrls: ['./gift.component.css']
})
export class GiftComponent {

  isCard = false;

  nombre: string = '';
  menu: string = 'Ninguno';

  constructor(private router: Router, private firestore: Firestore) {}

  cbuData() {
    this.isCard = true;
  }

  closeCard() {
    this.isCard = false;
  }

  goCreateAsist() {
    this.router.navigateByUrl('/personas');
  }

  // ✅ FORMATEAR FECHA
  getFechaFormateada(): string {
    const d = new Date();

    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const anio = String(d.getFullYear()).slice(-2);

    const horas = String(d.getHours()).padStart(2, '0');
    const minutos = String(d.getMinutes()).padStart(2, '0');

    return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
  }

  // ✅ GUARDAR INVITADO
  async guardarInvitado() {

    // 🔒 validación simple
    if (!this.nombre || this.nombre.trim() === '') {
      alert('Ingresá un nombre');
      return;
    }

    try {
      const invitadosRef = collection(this.firestore, 'invitados');

      await addDoc(invitadosRef, {
        nombre: this.nombre,
        menu: this.menu,
        fecha: this.getFechaFormateada(), // 👈 formateada
        pago: false
      });

      alert('Invitado guardado ✅');

      // limpiar form
      this.nombre = '';
      this.menu = 'Ninguno';
      this.isCard = false;

    } catch (error) {
      console.error(error);
      alert('Error al guardar ❌');
    }
  }
}